<article class="listing">
  <header class="listing__header">
    <h2 class="listing__title">{{ 'communications.title' | transloco }}</h2>
  </header>
  <section class="listing__table">
    <ng-container [ngTemplateOutlet]="Table"></ng-container>
  </section>
</article>

<!-- TODO: extract to components -->
<ng-template #Table>
  <article class="table">
    <header class="table__header">
      <ng-container [ngTemplateOutlet]="Filters"></ng-container>
      <ng-container [ngTemplateOutlet]="FilterTags"></ng-container>
    </header>
    <section *ngIf="(isLoading$ | async) === false || isDownloading" class="table__content">
      <sl-table
        [dataTable]="issuesTable"
        [showRowHover]="true"
        [showPagination]="false"
        [tableItemsName]="'communications.itemsName' | transloco"
        [totalPages]="totalTablePages"
        [pageIndex]="pageIndex"
        [pageSize]="pageSize"
        (pageChange)="onChangePage($event)"
        (rowClick)="onRowClick($event)"
      ></sl-table>
    </section>
  </article>
</ng-template>

<ng-template #Filters>
  <div class="filters">
    <sl-date-filter
      class="dropdown-filter"
      [showRangeFilter]="false"
      (selectedDates)="onDatePickerDates($event)"
      (removeSelectedDates)="onDatePickerRemove()"
    ></sl-date-filter>

    <div class="button-filters">
      <sl-button-filter-communications
        (submitFilters)="onSubmitFilters($event)"
        (discardFilters)="onDiscardFilters($event)"
      ></sl-button-filter-communications>
      <sl-button [type]="'link'" [icon]="'download'" [disabled]="isDownloading" (clicked)="onDownloadTable()">{{'Descargar'}}</sl-button>
    </div>
  </div>
</ng-template>

<ng-template #FilterTags>
  <div class="filter-tags"></div>
</ng-template>

<p-progressSpinner
  *ngIf="isLoading$ | async"
  [style]="{width: '100px', height: '100px'}"
  styleClass="custom-spinner"
  strokeWidth="2"
  animationDuration="1s"
></p-progressSpinner>

<!-- MODALS -->
<sl-communication-modal
  *ngIf="modalCommunication.show"
  [issue]="modalCommunication.issue!"
  [summary]="modalCommunication.summary!"
  (closeModal)="onCloseModalCommunication()"
  (sendIssueMessage)="onSendIssueMessageModal($event)"
  (markIssueMessageAsRead)="onMarkIssueMessageAsRead($event)"
></sl-communication-modal>

<sl-error-modal
  *ngIf="showErrorModal"
  [errorMessage]="'errorModal.message' | transloco"
  (closeModal)="showErrorModal = false"
></sl-error-modal>
